import { FormControlLabel } from '@material-ui/core';
import { FlatButton } from 'material-ui';
import * as React from 'react';
import { BenefitModel, ConclusionModel, GrabFormModel, ReviewModel, ServiceModel, UspModel, WorkModel } from '../../../../models'
import { ProjectViews } from '../../abstract';
// tslint:disable-next-line:ordered-imports
import { Views } from '../../../abstract';

interface IDashboardServiceAddEditViewProps extends Interfaces.IViewProps {
    onSave: () => void
    benefitSearchResult: BenefitModel[]
    postUspSearchResult: ConclusionModel[]
    uspSearchResult: UspModel[]
    onCreateContent: (type: string) => void
    onSearchContent: (s: string, t: string) => void
    formSearchResult: GrabFormModel.default[],
    reviewSearchResult: ReviewModel[],
    workSearchResult: WorkModel[],
    firendlyServiceSearchResult: ServiceModel[]
    projectSearchResult: ServiceModel[]
}


class DashboardServiceAddEditView<P, S> extends ProjectViews.CommonView<P & IDashboardServiceAddEditViewProps, S> {

    constructor(props: any) {
        super(props);
    }

    public onSelect(sItems: any, fName: string) {
        this.clearErrorLabel();
        const { model } = this.state;
        model[fName] = sItems;
        this.setState({ model });
    }

    public onSelectTextChange(s: string, name: any) {
        s = s.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '');
        const { onSearchContent } = this.props;
        return onSearchContent(s, name);
    }

    public validateForm() {
        const { onSave } = this.props;
        const { model } = this.state;
        if (model['title'].ru && model['title'].en) {
            if (model['shortDescription'].ru && model['shortDescription'].en) {
                if (model['keywords'].ru && model['keywords'].en) {
                    if (model['usp']) {
                        if (model['benefits'].length) {
                            if (model['img'].ru) {
                                if (model['img']['alt'].ru && model['img']['alt'].en) {
                                    if (model['conclusion']) {
                                        if (model['works'].length) {
                                            if (model['friendlyServices'].length) {
                                                if (model['minPrice']) {
                                                    model['usp'] = model['usp'].value
                                                    model['grabForm'] = model['grabForm'].value
                                                    model['conclusion'] = model['conclusion'].value
                                                    model['benefits'] = model['benefits'].map((b: any) => b.value)
                                                    model['works'] = model['works'].map((b: any) => b.value)
                                                    model['friendlyServices'] = model['friendlyServices'].map((b: any) => b.value)
                                                    model['projects'] = model['projects'].map((b: any) => b.value)
                                                    model['reviews'] = model['reviews'].map((b: any) => b.value)
                                                    model['position'] = model['position'] ? Number(model['position']) : undefined;
                                                    model['minPrice'] = model['minPrice'] ? Number(model['minPrice']) : undefined;
                                                    onSave();
                                                } else {
                                                    this.setState({ error: 'Укажите минимальную цену!' } as any)
                                                }
                                            } else {
                                                this.setState({ error: 'Добавьте дружественные услуги!' } as any)
                                            }
                                        } else {
                                            this.setState({ error: 'Добавьте работы!' } as any)
                                        }
                                    } else {
                                        this.setState({ error: 'Добавьте ПостУТП!' } as any)
                                    }
                                } else {
                                    this.setState({ error: 'Заполните описание изображения услуги на обоих языках!' } as any)
                                }
                            } else {
                                this.setState({ error: 'Загрузите изображение для русского языка!' } as any)
                            }
                        } else {
                            this.setState({ error: 'Добавьте преимущества! (Либо 3, либо 6 объектов)' } as any)
                        }
                    } else {
                        this.setState({ error: 'Добавьте УТП!' } as any)
                    }
                } else {
                    this.setState({ error: 'Заполните мета ключевые слова на обоих языках!' } as any)
                }
            } else {
                this.setState({ error: 'Заполните описание на обоих языках!' } as any)
            }
        } else {
            this.setState({ error: 'Заполните заголовок на обоих языках!' } as any)
        }
    }

    public renderLeftSide() {
        const { model, languageTabValue } = this.state;
        return (
            <React.Fragment>
                <Views.TextField
                    floatingLabelText="Наименование услуги"
                    fullWidth={true}
                    name="title"
                    value={model['title'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Описание (не более 250 символов)"
                    fullWidth={true}
                    multiLine={true}
                    maxlength="250"
                    name="shortDescription"
                    value={model['shortDescription'] && model['shortDescription'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Мета ключевые слова"
                    fullWidth={true}
                    multiLine={true}
                    name="keywords"
                    value={model['keywords'] && model['keywords'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Dropzone
                    file={model['img'][languageTabValue]}
                    onDrop={(files: any) => this.onDropImage(files, 'img')}
                    multiple={false}
                    onClear={() => this.onDropImage()}
                    accept="image/*"
                />
                <Views.TextField
                    floatingLabelText="Мета-описание изображения"
                    fullWidth={true}
                    name="img alt"
                    value={model['img']['alt'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Позиция в списке"
                    fullWidth={true}
                    data-type="number"
                    data-field-type="nml"
                    name="position"
                    value={model['position'] ? model['position'] : ''}
                    onChange={(e) => this.onTextChange(e)}
                />
            </React.Fragment>
        )
    }

    public renderRightSide() {
        const { model, languageTabValue } = this.state;
        const { formSearchResult, projectSearchResult, firendlyServiceSearchResult, workSearchResult, reviewSearchResult, onCreateContent, benefitSearchResult, uspSearchResult, postUspSearchResult } = this.props;
        return (
            <React.Fragment>
                <FormControlLabel
                    style={{ alignSelf: 'flex-start' }}
                    control={
                        <Views.Switch
                            checked={model['published']}
                            onChange={(e, c) => { model['published'] = c; this.setState({ model }) }}
                            color="black"
                        />
                    }
                    label="Опубликовано"
                />
                <Views.TextField
                    floatingLabelText="Минимальная цена"
                    fullWidth={true}
                    data-type="number"
                    data-field-type="nml"
                    name="minPrice"
                    value={model['minPrice'] ? model['minPrice'] : ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Select
                    name="select"
                    multi={false}
                    placeholder="УТП"
                    onInputChange={(s) => this.onSelectTextChange(s, 'Usp')}
                    onChange={(o: any) => this.onSelect(o, 'usp')}
                    options={uspSearchResult.map(e => ({ label: e.name, value: e }))}
                    value={model['usp']}
                />
                <FlatButton
                    label="Добавить новое УТП"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('usps')}
                />
                <Views.Select
                    name="select"
                    multi={true}
                    placeholder="Преимущества"
                    onInputChange={(s) => this.onSelectTextChange(s, 'Benefits')}
                    onChange={(o: any) => this.onSelect(o, 'benefits')}
                    options={benefitSearchResult.map(e => ({ label: e.name, value: e }))}
                    value={model['benefits']}
                />
                <FlatButton
                    label="Добавить новое Преимущество"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('benefits')}
                />
                <Views.Select
                    name="select"
                    multi={false}
                    placeholder="ПостУТП"
                    onInputChange={(s) => this.onSelectTextChange(s, 'conclusion')}
                    onChange={(o: any) => this.onSelect(o, 'conclusion')}
                    options={postUspSearchResult.map(e => ({ label: e.name, value: e }))}
                    value={model['conclusion']}
                />
                <FlatButton
                    label="Добавить новое ПостУТП"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('conclusions')}
                />
                <Views.TextField
                    floatingLabelText="Описание для секции работ(не более 250 символов)"
                    fullWidth={true}
                    multiLine={true}
                    maxlength="250"
                    name="worksUsp"
                    value={model['worksUsp'] && model['worksUsp'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Select
                    name="select"
                    multi={true}
                    placeholder="Работы"
                    onInputChange={(s) => this.onSelectTextChange(s, 'Works')}
                    onChange={(o: any) => this.onSelect(o, 'works')}
                    options={workSearchResult.map(e => ({ label: e.adminName, value: e }))}
                    value={model['works']}
                />
                <FlatButton
                    label="Добавить новую работу"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('works')}
                />
                <Views.Select
                    name="select"
                    multi={true}
                    placeholder="Отзывы"
                    onInputChange={(s) => this.onSelectTextChange(s, 'Reviews')}
                    onChange={(o: any) => this.onSelect(o, 'reviews')}
                    options={reviewSearchResult.map(e => ({ label: e.name, value: e }))}
                    value={model['reviews']}
                />
                <FlatButton
                    label="Добавить новый отзыв"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('reviews')}
                />
                <Views.Select
                    name="select"
                    multi={true}
                    placeholder="Дружественные услуги"
                    onInputChange={(s) => this.onSelectTextChange(s, 'FriendlyServices')}
                    onChange={(o: any) => this.onSelect(o, 'friendlyServices')}
                    options={firendlyServiceSearchResult.map(e => ({ label: e.title[languageTabValue as any], value: e }))}
                    value={model['friendlyServices']}
                />
                <FlatButton
                    label="Добавить новую услугу"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('services')}
                />
                <Views.Select
                    name="select"
                    multi={true}
                    placeholder="Проекты"
                    onInputChange={(s) => this.onSelectTextChange(s, 'Projects')}
                    onChange={(o: any) => this.onSelect(o, 'projects')}
                    options={projectSearchResult.map(e => ({ label: e.title[languageTabValue as any], value: e }))}
                    value={model['projects']}
                />
                <Views.Select
                    name="select"
                    multi={false}
                    placeholder="Форма захвата"
                    onInputChange={(s) => this.onSelectTextChange(s, 'GrabForm')}
                    onChange={(o: any) => this.onSelect(o, 'grabForm')}
                    options={formSearchResult.map(e => ({ label: e.name, value: e }))}
                    value={model['grabForm']}
                />
                <FlatButton
                    label="Добавить новую форму"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('grab-forms')}
                />
                <Views.Dropzone
                    file={model['metaImages'] ? model['metaImages']['fb'] : null}
                    onDrop={(files: any) => this.onDropImage(files, 'metaImages fb')}
                    multiple={false}
                    onClear={() => this.onDropImage(null, 'metaImages fb')}
                    placeholder="для meta Facebook и Twitter"
                    accept="image/*"
                />
                <Views.Dropzone
                    file={model['metaImages'] ? model['metaImages']['vk'] : null}
                    onDrop={(files: any) => this.onDropImage(files, 'metaImages vk')}
                    multiple={false}
                    onClear={() => this.onDropImage(null, 'metaImages vk')}
                    placeholder="для meta Vk"
                    accept="image/*"
                />
            </React.Fragment>
        )
    }
}

export default DashboardServiceAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/services/addedit/ServiceAddEditView.tsx